export enum FileType {
    video = "video",
    image = "image",
    application = "application",
    audio = "audio"
}